import { register, CloudObject, defineProperty, defineRelation } from 'olympe';

/**
 * @extends {CloudObject}
 */
export default class DocumentationArticle extends CloudObject {

    /**
     * Creates an instance of DocumentationArticle.
     *
     * @param {!Transaction} transaction
     * @return {!string} the tag of the created instance
     */
    static create(transaction) {
        return transaction.create(DocumentationArticle);
    }

    /**
     * @return {string}
     */
    getContent() {
        return this.get(DocumentationArticle.contentProp);
    }

    /**
     * @param {!BrickContext} $
     * @return {!Observable<string>}
     */
    observeContent($) {
        return this.observe($, DocumentationArticle.contentProp);
    }

    /**
     * @param {!Transaction} transaction
     * @param {!Tag} instance
     * @param {string} value
     */
    static setContent(transaction, instance, value) {
        transaction.update(instance, DocumentationArticle.contentProp, value);
    }

}

// Hardcoded tags
register('01998654a7b2aa02b5c0', DocumentationArticle);
DocumentationArticle.contentProp = defineProperty('01998659cc07cb7c7503');
DocumentationArticle.drawioDiagramRel = defineRelation('01998661b086152de31b');
